"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
/**
 * Gets the url
 * */
var RoutingAuditService = /** @class */ (function () {
    function RoutingAuditService(_injector) {
        this._injector = _injector;
    }
    RoutingAuditService_1 = RoutingAuditService;
    Object.defineProperty(RoutingAuditService.prototype, "_router", {
        get: function () {
            return this._injector.get(router_1.Router);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingAuditService.prototype, "_httpClient", {
        get: function () {
            return this._injector.get(idm_authentication_client_js_1.HttpClientWrapper);
        },
        enumerable: true,
        configurable: true
    });
    RoutingAuditService.prototype.listen = function () {
        var _this = this;
        return this._router.events
            .filter(function (event) { return event instanceof router_1.NavigationEnd; })
            .subscribe(function (value) {
            _this._httpClient
                .post(RoutingAuditService_1.ACTION_URL, {
                url: value.url
            }, { responseType: 'text' })
                .toPromise()
                .catch(function (e) { return console.log(e); });
        });
    };
    var RoutingAuditService_1;
    RoutingAuditService.ACTION_URL = 'navigate';
    RoutingAuditService = RoutingAuditService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [core_1.Injector])
    ], RoutingAuditService);
    return RoutingAuditService;
}());
exports.RoutingAuditService = RoutingAuditService;
//# sourceMappingURL=routing-audit.service.js.map